export default "__VITE_ASSET__DPDVe7sW__"